module.exports = __webpack_public_path__ + "img/制天南星.156c2957.jpg";